

export const index = 1;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/fallbacks/error.svelte.js')).default;
export const imports = ["_app/immutable/nodes/1.-maQa7w4.js","_app/immutable/chunks/2pkelJKV.js","_app/immutable/chunks/DdPEVikY.js","_app/immutable/chunks/BfCX6gG4.js","_app/immutable/chunks/CvVWqU2v.js"];
export const stylesheets = [];
export const fonts = [];
